<template>
    <InformeCard @click="draw" title="Edades" v-if="totalEdades" id="edades" name="edades" collapsable="true">
        <h4 class="text-center">Estadísticas de Edades</h4>
        <GChart
            type="ColumnChart"
            :resizeDebounce="100"
            :data="totalEdades"
            :options="chartOptions"
            ref="googleChart"
        />
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['event_id'],
        data() {
            return {
                totalEdades: [],
                chartOptions: {
                    height: 400,
                    chartArea:{ width: 750 }
                }
            }
        },
        methods: {
            getTotalEdades() {
                const params = {
                    filters : {},
                    evento_id: this.event_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.informe.total-edades'), params).then(res => {
                    this.totalEdades = res.data;
                    this.$emit('totalEdades', this.totalEdades);
                });
            },
            draw() {
                setTimeout(() => {
                    this.$refs.googleChart.drawChart()
                }, 50)
            }
        },
        created() {
            this.getTotalEdades();
        },
        components: {
            InformeCard
        }
    }

</script>